export const vapidKeyFrom = (env: Readonly<Record<string, unknown>>): string | null => {
  const key = env.VITE_VAPID_PUBLIC_KEY;
  if (typeof key !== 'string') return null;
  const trimmed = key.trim();
  return trimmed === '' ? null : trimmed;
};

export const configuredVapidKey = (): string | null => vapidKeyFrom({ VITE_VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY });
